import { CategoryWithStatus } from 'src/dtos/category-with-status.dto';
import { FilterConfig } from 'src/model/filter';
import { CategoriesFilterNames } from 'src/utils/enums';
import { useStores } from 'src/components/store';

export const useCategoryFiltersConfig = (): FilterConfig<CategoryWithStatus> => {
    const {customerStore} = useStores();
    const isPremium = customerStore.isPremium;

    return {
        searchBox: {placeholder: 'Search Category', byFields: ['categoryTitle']},
        localStorageKey: 'categoryDefaultFilter',
        radioButtons: {
            defaultSelectionIndex: 0,
            options: [
                {label: CategoriesFilterNames.All, filterFn: () => true},
                {label: CategoriesFilterNames.Blocked, filterFn: (category: CategoryWithStatus) => !category.isAllow},
                {label: CategoriesFilterNames.Allowed, filterFn: (category: CategoryWithStatus) => category.isAllow},
                {label: CategoriesFilterNames.HighRiskCategories, filterFn: (category: CategoryWithStatus) => category.blockedByDefault},
                ...(isPremium ? [{label: CategoriesFilterNames.AICategories, filterFn: (category: CategoryWithStatus) =>
                        category.categoryName.startsWith('AI') || category.categoryName === 'artificial-intelligence'}] : [])
            ]
        },
    };
};